// buttonLinks.js
var ButtonLinks = pc.createScript('buttonLinks');
ButtonLinks.attributes.add('theLink', {type: 'string', title: 'link'});

// initialize code called once per entity
ButtonLinks.prototype.initialize = function() {
    this.entity.element.on('mousedown', this.onPress, this);
    this.entity.element.on('touchstart', this.onTouch, this);
};

ButtonLinks.prototype.onTouch = function() {
    window.open(window.location.href = this.theLink, window.location.target = '_blank');
    //window.open(this.theLink);
};

ButtonLinks.prototype.onPress = function() {
    window.open(this.theLink); 
};

// update code called every frame
ButtonLinks.prototype.update = function(dt) {
    
};

// swap method called for script hot-reloading
// inherit your script state here
// ButtonLinks.prototype.swap = function(old) { };

// to learn more about script anatomy, please read:
// http://developer.playcanvas.com/en/user-manual/scripting/

